import React from 'react';
import { ArrowRight, Play, ChevronDown } from 'lucide-react';
import { trackLead } from '../utils/metaPixel';

const CTASection = () => {
  const scrollToPathway = () => {
    document.querySelector('#pathway')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="section-padding bg-[var(--bg-dark)]">
      <div className="container px-4 sm:px-10">
        <div className="max-w-3xl mx-auto text-center">
          {/* Video Section */}
          <div className="mb-12">
            <h2 className="heading-2 text-[var(--text-inverse)] mb-4">
              Still Thinking?
            </h2>
            <p className="body-large text-gray-400 mb-6">
              Watch this before you decide.<br />
              This 3-minute video will change how you look at family protection.<br />
              <span className="text-sm">Recommended for serious families before booking.</span>
            </p>
            
            {/* Video Embed */}
            <div className="relative bg-black rounded-lg overflow-hidden aspect-video mb-4 max-w-2xl mx-auto">
              <video 
                className="w-full h-full"
                controls
                preload="metadata"
                poster=""
              >
                <source 
                  src="https://customer-assets.emergentagent.com/job_b2ceecb0-da08-477c-bdbc-45b3f8bca466/artifacts/xs4nlott_ScreenRecording_03-18-2026%2013-24-59_1.MP4" 
                  type="video/mp4" 
                />
                Your browser does not support the video tag.
              </video>
            </div>
            
            <p className="body-small text-gray-500 italic">
              Clarity removes confusion. This will help you see things differently.
            </p>
          </div>
          
          {/* Main CTA Content */}
          <p className="eyebrow-gold uppercase tracking-widest mb-6">
            Ready to Begin?
          </p>
          
          <h2 className="hero-medium text-[var(--text-inverse)] mb-6">
            Start your journey to
            <span className="block text-[var(--gold-primary)]">family protection certainty.</span>
          </h2>
          
          <p className="body-large text-gray-400 mb-10">
            No pressure. No selling. Just calm clarity for your family’s protection.
          </p>
          
          {/* CTA Buttons - Both gold, permanently visible */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-4">
            <a
              href="https://wa.me/9172096199"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold"
              onClick={() => trackLead('WhatsApp CTA Click')}
            >
              Start on WhatsApp
              <ArrowRight size={16} />
            </a>
            <button
              onClick={scrollToPathway}
              className="btn-gold"
            >
              Choose Your Tier
              <ChevronDown size={16} />
            </button>
          </div>
          
          {/* CTA micro-filter */}
          <p className="text-xs text-gray-500 mb-10">
            Serious families only • No quotes • No product selling
          </p>
          
          {/* Tagline */}
          <div className="inline-block">
            <div className="divider mx-auto mb-4"></div>
            <p className="body-regular text-gray-500 italic">
              "Not selling insurance. Building certainty."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
